// extracted by mini-css-extract-plugin
export var footerSocialItem = "social-medias-module--footer-social-item--a1876";
export var footerSocialLinks = "social-medias-module--footer-social-links--863aa";